let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ftXvl")).then(() => parcelRequire('hVcoC'));